import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import Glide, { Anchors } from '@glidejs/glide/dist/glide.modular.esm';
import ReactHtmlParser from 'react-html-parser';
import {
  Link,
  Heading,
  Paragraph,
  VideoPlayer,
  Image,
  Button,
  HashtagList,
} from 'components';
import './MainSlider.scss';
import { data } from './logic';

class AboutSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSlideIndex: 0,
      windowWidth: 0,
    };
  }

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    this.glide = new Glide('.glide', {
      type: 'slideshow',
      animationDuration: 0,
      dragThreshold: false,
    });

    this.glide.on(['build.after', 'run.after'], () => {
      const video = document.querySelector(
        `.main-slider__video-${this.glide.index} video`,
      );
      this.setState({ currentSlideIndex: this.glide.index });

      if (video) {
        video.currentTime = 0;
        video.play();
      }
    });

    Event.prototype.stopPropagation = function() {};

    this.glide.mount({ Anchors });
  }

  componentWillUnmount() {
    this.glide.destroy();
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  handleNextSlide = () => this.glide.go('>');

  renderSlides = (homepageIntroHeight, loadedData) => {
    const { windowWidth, currentSlideIndex } = this.state;

    return data.map((item, index) => {
      const linkId = `${item.intro.split(',')[0].toLowerCase()}`;

      return (
        <li
          className={'main-slider__slide-container glide__slide'}
          // eslint-disable-next-line react/no-array-index-key
          key={`main-slide-${index}`}
        >
          {currentSlideIndex === index && (
            <div
              style={{
                height:
                  windowWidth > 1200
                    ? `calc(100vh - ${homepageIntroHeight}px)`
                    : '',
              }}
              className={`main-slider__slide-wrapper main-slider__slide-wrapper--${
                item.color
              }`}
            >
              <div className={'main-slider__top'} />
              <div className={'w-container w-container--left'}>
                <Link to={item.link} arrow>
                  <div className={'main-slider__body'}>
                    <div className={'main-slider__box'}>
                      {item.logo && (
                        <div className={'main-slider__image-wrapper'}>
                          <Image
                            src={loadedData[item.logo].childImageSharp.fluid}
                            additionalClass={'main-slider__image'}
                          />
                        </div>
                      )}
                      <Heading
                        type={2}
                        additionalClass={'main-slider__box-headline'}
                      >
                        {item.headline}
                      </Heading>
                      <Paragraph
                        color={'gray-dark'}
                        additionalClass={'main-slider__box-content'}
                        spaced
                      >
                        {ReactHtmlParser(item.description)}
                      </Paragraph>
                      <Button
                        id={`main-slider-${linkId}`}
                        order={'secondary'}
                        color={'black'}
                      >
                        Case study
                      </Button>
                    </div>
                    <div className={'main-slider__hashtags'}>
                      <HashtagList
                        color={'gray-medium'}
                        data={item.tags}
                        tagSize={'small-plus'}
                        tagClass={'text--light'}
                      />
                    </div>
                  </div>
                </Link>
              </div>
              <div className={'main-slider__media'}>
                <Link to={item.link}>
                  {windowWidth > 767 ? (
                    <VideoPlayer
                      containerClass={'main-slider__slide'}
                      playerClass={`main-slider__video-${index}`}
                      src={item.video}
                      onEnded={this.handleNextSlide}
                      playing={index === currentSlideIndex}
                      width={
                        windowWidth >= 768 && windowWidth < 992
                          ? '100%'
                          : 'auto'
                      }
                      height={
                        windowWidth >= 768 && windowWidth < 992
                          ? 'auto'
                          : '100%'
                      }
                      muted
                      config={{
                        file: { attributes: { preload: 'metadata' } },
                      }}
                    />
                  ) : (
                    <Image
                      src={loadedData[item.image].childImageSharp.fluid}
                      additionalClass={'main-slider__slide'}
                    />
                  )}
                </Link>

                <div
                  className={`main-slider__teaser-wrapper main-slider__teaser-wrapper--${
                    item.color
                  }`}
                  onClick={this.handleNextSlide}
                  role={'presentation'}
                  id={'main-slider-next'}
                >
                  <div className={'main-slider__teaser'}>
                    <Paragraph color={'white'} size={'default'}>
                      Next
                    </Paragraph>
                    <span className={'main-slider__next-headline'}>
                      {data[index + 1]
                        ? data[index + 1].headline
                        : data[0].headline}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </li>
      );
    });
  };

  render() {
    let homepageIntroHeight = 200;
    if (
      typeof document !== 'undefined' &&
      document.getElementById('home-intro')
    ) {
      homepageIntroHeight = document.getElementById('home-intro').offsetHeight;
    }

    return (
      <StaticQuery
        query={graphql`
          query {
            sonnenLogo: file(relativePath: { eq: "logos/sonnen-logo.png" }) {
              childImageSharp {
                fluid(maxWidth: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            sonnenImg: file(
              relativePath: { eq: "main-banner/sonnen-banner.jpg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 1280) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            takamolLogo: file(relativePath: { eq: "logos/takamol-logo.png" }) {
              childImageSharp {
                fluid(maxWidth: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            takamolImg: file(
              relativePath: { eq: "main-banner/takamol-banner.jpg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 1280) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            hackthewindLogo: file(
              relativePath: { eq: "logos/hack-the-wind-2018-hackathon.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            hackthewindImg: file(
              relativePath: { eq: "main-banner/wind-turbine-banner.jpeg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 1050) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={loadedData => (
          <div className={'main-slider__wrapper'}>
            <div className={'main-slider glide'}>
              <div data-glide-el={'track'} className={'glide__track'}>
                <ul className={'glide__slides'}>
                  {typeof window !== 'undefined' &&
                    window.location &&
                    this.renderSlides(homepageIntroHeight, loadedData)}
                </ul>
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

export default AboutSlider;
